/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class ApplicationInfoService {
    /** @ngInject */
    constructor($http, $log, url) {
        this.$http = $http;
        this.$log = $log;
        this.url = url;
        this.$log.debug('Service \'ApplicationInfoService\' loaded');
    }

    findApplicationInfo() {
        return this.$http({
            method: 'GET',
            url: this.url,
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': undefined
            }
        }).then(response => {
            return {
                applicationInfo: response.data
            };
        });
    }
}

export { ApplicationInfoService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/service/ApplicationInfoService.js